/*
 * Lapis Magica UI: cart drawer + cart page behaviour (2026 redesign).
 *
 * - <cart-drawer> keeps the API Dawn's product-form.js and the card add-to-cart in lm-ui.js
 *   call (getSectionsToRender / renderContents / setActiveElement), so every add opens it.
 * - Quantity steps, Remove and the suggestion "Add" buttons go through the Ajax Cart API
 *   (/cart/change.js, /cart/add.js) and ask Shopify for the re-rendered sections in the same
 *   request: the drawer, the header count and, on /cart, the page section. Nothing is
 *   rebuilt in JS, so prices and the free-shipping bar always come from Liquid.
 * - Optimistic quantity: the number changes at once and rolls back with a message on error.
 * - The controls are real links (/cart/change?line=..., remove URLs), so the cart still works
 *   with JS off.
 */
(function () {
  if (customElements.get('cart-drawer')) return;

  var BG = document.documentElement.lang === 'bg';
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');

  function pageSection() {
    var p = document.getElementById('LmCartPage');
    return p ? p.dataset.sectionId : null;
  }
  function sectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var ps = pageSection();
    if (ps) ids.push(ps);
    return ids;
  }
  function parse(html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(sel);
  }

  // Swap every re-rendered section that came back with a cart response.
  function applySections(sections) {
    if (!sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (sections['cart-drawer'] && drawer) {
      var src = parse(sections['cart-drawer'], '#CartDrawer');
      var dst = drawer.querySelector('#CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
      var srcEl = parse(sections['cart-drawer'], 'cart-drawer');
      if (srcEl) drawer.classList.toggle('is-empty', srcEl.classList.contains('is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var b = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && b) bubble.innerHTML = b.innerHTML;
    }
    var ps = pageSection();
    if (ps && sections[ps]) {
      var page = document.getElementById('LmCartPage');
      var pn = parse(sections[ps], '#LmCartPage');
      if (page && pn) page.innerHTML = pn.innerHTML;
    }
  }

  function post(url, body) {
    return fetch(root.replace(/\/$/, '') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  function announce(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lm-cart', cartData: cart });
    }
  }

  // ---------- quantity / remove ----------
  function changeLine(row, qty) {
    var line = parseInt(row.dataset.lmLine, 10);
    var oldQty = parseInt(row.dataset.qty, 10);
    var max = row.dataset.max ? parseInt(row.dataset.max, 10) : null;
    var err = row.querySelector('.lm-cline__err');
    if (max !== null && qty > max) {
      showErr(err, (BG ? 'Налични: ' : 'Only ') + max + (BG ? '' : ' available'));
      return;
    }
    var n = row.querySelector('.lm-step__n');
    if (n) n.textContent = qty;          // optimistic
    row.setAttribute('aria-busy', 'true');
    if (qty === 0) row.classList.add('is-removing');
    post('/cart/change.js', { line: line, quantity: qty, sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Error');
        applySections(res.json.sections);
        announce(res.json);
        var d = document.querySelector('cart-drawer');
        if (d && d.classList.contains('active')) d.focusFirst();
      })
      .catch(function (e) {
        if (n) n.textContent = oldQty;   // roll back
        row.classList.remove('is-removing');
        row.removeAttribute('aria-busy');
        showErr(err, e.message);
      });
  }
  function showErr(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-lm-step]');
    var rm = e.target.closest('[data-lm-remove]');
    var t = step || rm;
    if (!t) return;
    var row = t.closest('[data-lm-line]');
    if (!row) return;
    e.preventDefault();
    if (t.getAttribute('aria-disabled') === 'true') return;
    if (row.getAttribute('aria-busy') === 'true') return;
    var qty = parseInt(row.dataset.qty, 10);
    changeLine(row, rm ? 0 : Math.max(0, qty + parseInt(step.dataset.lmStep, 10)));
  });

  // ---------- suggestion "Add" buttons ----------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-lm-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    post('/cart/add.js', {
      items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }],
      sections: sectionIds(),
      sections_url: window.location.pathname
    })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || 'Error');
        applySections(res.json.sections);
        announce(res.json);
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.title = err.message; }
      });
  });

  // ---------- "Shipping to" on the cart page ----------
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'LmCartCountry') e.target.form.submit();
  });

  // ---------- the drawer ----------
  class LmCartDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('keyup', function (e) { if (e.code === 'Escape') self.close(); });
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-lm-cd-close]') || e.target.id === 'CartDrawer-Overlay') self.close();
      });
      var link = document.getElementById('cart-icon-bubble');
      // On /cart the header pill just stays a link to the page you are on.
      if (link && !document.getElementById('LmCartPage')) {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', function (e) { e.preventDefault(); self.open(link); });
        link.addEventListener('keydown', function (e) {
          if (e.code === 'Space') { e.preventDefault(); self.open(link); }
        });
      }
    }
    open(trigger) {
      if (trigger) this.activeElement = trigger;
      var self = this;
      // a timer, not requestAnimationFrame: rAF is paused in background tabs
      setTimeout(function () {
        self.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden', 'lm-cd-open');
        self.focusFirst();
      }, 20);
    }
    focusFirst() {
      var panel = this.querySelector('#CartDrawer');
      if (typeof trapFocus === 'function') trapFocus(panel, this.querySelector('.lm-cd__close') || panel);
      else panel.focus();
    }
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden', 'lm-cd-open');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      else if (this.activeElement) this.activeElement.focus();
    }
    setActiveElement(el) { this.activeElement = el; }
    getSectionsToRender() {
      return sectionIds().map(function (id) { return { id: id }; });
    }
    // Called by product-form.js and lm-ui.js after an add.
    renderContents(parsed) {
      applySections(parsed.sections);
      this.open();
    }
  }
  customElements.define('cart-drawer', LmCartDrawer);

  // "Added to cart ✓" on the product page button for 1.5 s.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      document.querySelectorAll('.product-form__submit > span:not(.sold-out-message):not(.loading__spinner)').forEach(function (s) {
        if (s.dataset.lmOrig) return;
        s.dataset.lmOrig = s.textContent;
        s.textContent = BG ? 'Добавено в количката ✓' : 'Added to cart ✓';
        setTimeout(function () { s.textContent = s.dataset.lmOrig; delete s.dataset.lmOrig; }, 1500);
      });
    });
  }
})();
